var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 7.5,
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36811 10.3169C7.10149 10.561 6.67081 10.561 6.40419 10.3169L3.94995 8.06964C3.82194 7.95269 3.75 7.79391 3.75 7.62833C3.75 7.46274 3.82194 7.30396 3.94995 7.18701C4.21657 6.94288 4.64726 6.94288 4.91387 7.18701L6.88273 8.98983L11.5861 4.6831C11.8527 4.43897 12.2834 4.43897 12.55 4.6831C12.8167 4.92723 12.8167 5.3216 12.55 5.56573L7.36811 10.3169Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCheckmark);
export default __webpack_public_path__ + "static/media/table-checkmark.20fc58e29f8d19f008f619f90d9c2c80.svg";
export { ForwardRef as ReactComponent };